/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */
import React, { useState, useEffect } from 'react';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../../locales/en-US/descriptors';
import withErrorStatus from '../../../shared/StatusWrappers/ErrorStatus';
import withLoadingStatus from '../../../shared/StatusWrappers/LoadingStatus';
import ConnectionError from '../../../shared/ErrorComponents/ConnectionError';
import { isObjectOrArrayAndEmpty } from '../../../shared/Utils/Utils';
import {
  ICarbonScopeOneData,
  IDetailComponentProps,
  IDetailComponentPropsApiSeparate
} from '../../../DashboardKPIWidgets/IEnergyManagementProps';
import { Card } from '@scuf/common';
import PortfolioCarbonScopeOneSavingsBySiteDetailComponent from '../PortfolioCarbonScopeOneSavingsBySiteWidget/PortfolioCarbonScopeOneSavingsBySiteDetailComponent';
interface IPortfolioCarbonScopeTwoSavingsBySiteComponentContent {
  data: ICarbonScopeOneData;
  UtilityBillType: string;
  onRefresh: () => Promise<void>;
}
export const PortfolioCarbonSavingsBySiteComponentContent = (
  props: IPortfolioCarbonScopeTwoSavingsBySiteComponentContent
) => {
  const d = descriptors.energyManagement;
  const [t] = useTranslation();
  const { data, onRefresh, UtilityBillType } = props;
  if (isObjectOrArrayAndEmpty(data)) {
    return (
      <div className="errorDisplay">
        <ConnectionError
          title={t(d.CONNECTIONERRORTITLE)}
          message={t(d.CONNECTIONERROR)}
          onRefresh={onRefresh}
        />
      </div>
    );
  }
  return (
    <div>
      <PortfolioCarbonScopeOneSavingsBySiteDetailComponent
        data={data}
        UtilityBillType={UtilityBillType}
      />
    </div>
  );
};
const PortfolioCarbonScopeTwoSavingsBySiteComponentWithLoader = withLoadingStatus(
  withErrorStatus(PortfolioCarbonSavingsBySiteComponentContent)
);
const PortfolioCarbonScopeTwoSavingsBySiteComponentSeparate = (
  props: IDetailComponentPropsApiSeparate
) => {
  const { dataConnectorForTable, UtilityBillType } = props;
  const [t] = useTranslation();
  const d = descriptors.energyManagement;

  const allTable = dataConnectorForTable?.data.all;
  const loadingTable = dataConnectorForTable?.data.loading;
  const errorTable = dataConnectorForTable?.data.error;
  const statusTable = dataConnectorForTable?.data.status;
  const carbonScopeTwoSavingsData = (allTable as unknown) as ICarbonScopeOneData;
  const isDataAvailableTable =
    carbonScopeTwoSavingsData && carbonScopeTwoSavingsData.breakdownBySite
      ? true
      : false;

  const [isLoadingTable, setIsLoadingTable] = useState<boolean>(loadingTable);
  const [statusCodeTable, setStatusCodeTable] = useState<number | null>(0);
  const [errorInfoTable, setErrorInfoTable] = useState(errorTable);
  const [dataTable, setDataTable] = useState({} as ICarbonScopeOneData);
  const onRefreshTable = () =>
    dataConnectorForTable &&
    dataConnectorForTable.actions &&
    dataConnectorForTable.actions.getAll();

  useEffect(() => {
    setIsLoadingTable(loadingTable);
    if ((isDataAvailableTable || errorTable || statusTable) && !loadingTable) {
      if (isDataAvailableTable) {
        let tempData: any = carbonScopeTwoSavingsData;
        setDataTable(tempData);
      }
      setErrorInfoTable(errorTable);
      setStatusCodeTable(statusTable);
    }
  }, [isDataAvailableTable, loadingTable, statusTable]);

  return (
    <Card className="Savemeter">
      <Card.Header className="emaas-carbon-view-details-total-emissions-savings-meter-card-header">
        <div className="emaas-site-count-header">
          <div>
            {t(d.breakdownCarbonSites, {
              count: dataTable.breakdownBySite?.length || 0
            })}
          </div>
          <div>{t(d.SITEWITHDATA)}</div>
        </div>
      </Card.Header>
      <Card.Content>
        <div className="meter-savings-Datatable detail-view">
          <PortfolioCarbonScopeTwoSavingsBySiteComponentWithLoader
            loading={isLoadingTable}
            error={errorInfoTable}
            statusCode={statusCodeTable}
            onRefresh={onRefreshTable}
            data={dataTable}
            loadingText={t(d.LOADING)}
            title={t(d.CONNECTIONERRORTITLE)}
            noDataMessage={t(d.NODATAAVAILABLE)}
            connectionErrorMessage={t(d.CONNECTIONERROR)}
            UtilityBillType={UtilityBillType || ''}
          />
        </div>
      </Card.Content>
    </Card>
  );
};
export default PortfolioCarbonScopeTwoSavingsBySiteComponentSeparate;
